import { render, staticRenderFns } from "./InsFooterLayout.vue?vue&type=template&id=1596f0a1&scoped=true&"
import script from "./InsFooterLayout.vue?vue&type=script&lang=ts&"
export * from "./InsFooterLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InsFooterLayout.vue?vue&type=style&index=0&id=1596f0a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596f0a1",
  null
  
)

export default component.exports